import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNowStrict } from 'date-fns';
import WorldIcon from '@atlaskit/icon/glyph/world';
import { trackLinkClick } from '@atlassian/temp-analytics';
import { CloudLicenseResults, CommerceAddress } from '@css-xp/graphtypes/src/generated-types-new';
import './widget-items.scss';

type CloudSiteWidgetItemType = Pick<CloudLicenseResults, 'cloudSiteUrl'> & {
  url: string;
  timestamp: number;
  companyName: CommerceAddress['name'];
  heading?: string;
  version?: number;
};
/**
 * Component for CloudSite Widget on the Home page
 * @constructor
 */
const CloudSiteWidgetItemsComponent = ({
  url,
  timestamp,
  companyName,
  cloudSiteUrl,
  heading = '',
  version,
}: CloudSiteWidgetItemType) => {
  const isVersion2 = version === 2;
  const renderSubTitle = () => {
    return <div className="sub-title line-ellipsis">{companyName ? companyName : null}</div>;
  };
  const renderTitle = () => {
    return <div className="title line-ellipsis">{cloudSiteUrl}</div>;
  };

  return (
    <div className="flex justify-space-between mb-12 pv-12 cloud-site-widget-item">
      <div className="left-side">
        <div className="content">
          <Link
            to={url}
            onClick={() => {
              trackLinkClick('widgetItemClick', { source: heading });
            }}
          >
            <div className="flex">
              {isVersion2 ? (
                <>
                  <span className="widget-item-icon">
                    <WorldIcon label="Cloud site icon" size="small" />
                  </span>
                  <div className="align-self-center">
                    {renderTitle()}
                    {renderSubTitle()}
                  </div>
                </>
              ) : (
                renderTitle()
              )}
            </div>
          </Link>
        </div>
        {isVersion2 || (
          <div className="content" data-testid="sub-title">
            {renderSubTitle()}
          </div>
        )}
      </div>
      <div className="right-side">
        <div className="content">
          <div className="timestamp">{formatDistanceToNowStrict(new Date(timestamp), { addSuffix: true })}</div>
        </div>
      </div>
    </div>
  );
};

export const CloudSiteWidgetItem = React.memo(CloudSiteWidgetItemsComponent);
